import { api } from ".";

interface IFinixProviderStatus {
  id: string;
  name: string;
  specialty: string;
  mainFacility: boolean;
  finixMerchantId: string | null;
  onboardingStatus: string | null;
  onboardingFormId: string | null;
  onboardingUrl: string | null;
}

interface IFinixReadiness {
  allProvidersOnboarded: boolean;
  facilityOnboarded: boolean;
  activePaymentPlansNeedingMigration: number;
  ready: boolean;
}

interface IFinixOnboardingOverview {
  providers: IFinixProviderStatus[];
  readiness: IFinixReadiness;
}

interface IFinixOnboardingResult {
  formId: string;
  url: string;
  status: string;
}

const finixAdminQueries = api.injectEndpoints({
  endpoints: (builder) => ({
    getFinixOnboardingOverview: builder.query<IFinixOnboardingOverview, string>(
      {
        query: (accountId) => ({
          url: `/finix/onboarding/account/${accountId}/overview`,
          method: "GET",
        }),
        providesTags: ["FinixOnboarding"],
      }
    ),
    startAccountOnboarding: builder.mutation<IFinixOnboardingResult, string>({
      query: (accountId) => ({
        url: `/finix/onboarding/account/${accountId}`,
        method: "POST",
      }),
      invalidatesTags: ["FinixOnboarding"],
    }),
    startProviderOnboarding: builder.mutation<IFinixOnboardingResult, string>({
      query: (providerId) => ({
        url: `/finix/onboarding/provider/${providerId}`,
        method: "POST",
      }),
      invalidatesTags: ["FinixOnboarding"],
    }),
    reissueOnboardingLink: builder.mutation<IFinixOnboardingResult, string>({
      query: (formId) => ({
        url: `/finix/onboarding/${formId}/link`,
        method: "POST",
      }),
      invalidatesTags: ["FinixOnboarding"],
    }),
  }),
});

export const {
  useGetFinixOnboardingOverviewQuery,
  useStartAccountOnboardingMutation,
  useStartProviderOnboardingMutation,
  useReissueOnboardingLinkMutation,
} = finixAdminQueries;
